import { render, staticRenderFns } from "./reason.vue?vue&type=template&id=a4bc7f46&scoped=true&"
import script from "./reason.vue?vue&type=script&lang=js&"
export * from "./reason.vue?vue&type=script&lang=js&"
import style0 from "./reason.vue?vue&type=style&index=0&id=a4bc7f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bc7f46",
  null
  
)

export default component.exports